/**
 * Whether a failed read is asked for a second time (#724).
 *
 * The app's default is one retry, which helps a read that failed on a network blip or a cold server.
 * It does not help a read the server answered with "there is no such thing": a person's id that does
 * not exist is a 404 today, a second later and always, and asking again only keeps the page spinning
 * for seconds before it says so. A 404 is therefore never retried; anything else keeps the one retry.
 *
 * The status is the one `getJson` in `api.real.ts` attaches to the error it throws.
 */
export const RETRIES_AFTER_FAILURE = 1;

export function retryRead(failureCount: number, error: unknown): boolean {
  if (typeof error === 'object' && error !== null && 'status' in error && error.status === 404) return false;
  return failureCount < RETRIES_AFTER_FAILURE;
}
